"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carlineConsumptionFromRawStrategy = void 0;
const transform_types_1 = require("../../../types/transform.types");
const misc_1 = require("../../../utils/misc");
const range_1 = require("../../../utils/range");
const vehicleKey_1 = require("../../../utils/vehicleKey");
const vehicleType_1 = require("../../../utils/vehicleType");
const constants_1 = require("../../constants");
const mustacheRenderer_1 = require("../../renderer/mustacheRenderer");
const textResources_1 = require("../../textResources");
const carlineConsumptionFromRawStrategy = ({ carline, locale, i18nlanguage }, ret) => {
    const { fuelConsumptionWltpCombinedMax, fuelConsumptionWltpCombinedMin, electricConsumptionWltpCombinedMin, electricConsumptionWltpCombinedMax, fuelConsumptionWltpUnit, electricConsumptionWltpCombinedUnit, } = carline.eecModel;
    const resources = new textResources_1.I18nText(locale, i18nlanguage);
    const vehicleType = (0, vehicleType_1.getVehicleTypeForCarline)(carline);
    const isHybridAndValuesExist = vehicleType === transform_types_1.VehicleTypeEnum.OVCHEV &&
        (0, misc_1.isDefined)(fuelConsumptionWltpCombinedMax) &&
        (0, misc_1.isDefined)(fuelConsumptionWltpCombinedMin) &&
        // TODO: We should use fuelConsumptionWltpCombinedUnit, but it was not defined in the response at the time of writing
        (0, misc_1.isDefined)(fuelConsumptionWltpUnit) &&
        (0, misc_1.isDefined)(electricConsumptionWltpCombinedMin) &&
        (0, misc_1.isDefined)(electricConsumptionWltpCombinedMax) &&
        (0, misc_1.isDefined)(electricConsumptionWltpCombinedUnit);
    const isElectricAndValuesExist = vehicleType === transform_types_1.VehicleTypeEnum.PEV &&
        (0, misc_1.isDefined)(electricConsumptionWltpCombinedMin) &&
        (0, misc_1.isDefined)(electricConsumptionWltpCombinedMax) &&
        (0, misc_1.isDefined)(electricConsumptionWltpCombinedUnit);
    const isNormalAndValuesExist = (vehicleType === transform_types_1.VehicleTypeEnum.ICE || vehicleType === transform_types_1.VehicleTypeEnum.NOVCHEV) &&
        (0, misc_1.isDefined)(fuelConsumptionWltpCombinedMax) &&
        (0, misc_1.isDefined)(fuelConsumptionWltpCombinedMin) &&
        (0, misc_1.isDefined)(fuelConsumptionWltpUnit);
    if (isHybridAndValuesExist) {
        const templateKey = `vue.range.consumption.combined.hybrid`;
        const view = {
            consumption1: {
                combined: {
                    formatted: (0, range_1.formatRangeValue)(locale, {
                        min: fuelConsumptionWltpCombinedMin,
                        max: fuelConsumptionWltpCombinedMax,
                        unit: fuelConsumptionWltpUnit,
                    }, range_1.CONSUMPTION_FRACTION_DIGITS),
                },
            },
            consumption0: {
                combined: {
                    formatted: (0, range_1.formatRangeValue)(locale, {
                        min: electricConsumptionWltpCombinedMin,
                        max: electricConsumptionWltpCombinedMax,
                        unit: electricConsumptionWltpCombinedUnit,
                    }, range_1.CONSUMPTION_FRACTION_DIGITS),
                },
            },
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        };
        ret.formattedConsumption = (0, mustacheRenderer_1.substituteTemplate)(resources.get(templateKey), view);
    }
    if (isElectricAndValuesExist || isNormalAndValuesExist) {
        const templateKey = `vue.range.consumption.combined.${(0, vehicleKey_1.getVehicleKeyForVehicleType)(vehicleType)}`;
        const min = isElectricAndValuesExist ? electricConsumptionWltpCombinedMin : fuelConsumptionWltpCombinedMin;
        const max = isElectricAndValuesExist ? electricConsumptionWltpCombinedMax : fuelConsumptionWltpCombinedMax;
        const unit = isElectricAndValuesExist ? electricConsumptionWltpCombinedUnit : fuelConsumptionWltpUnit;
        if (min && max && unit) {
            const view = {
                consumptionRange: (0, range_1.formatRangeValue)(locale, { min, max, unit }, range_1.CONSUMPTION_FRACTION_DIGITS),
                footnote: {
                    reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
                },
            };
            ret.formattedConsumption = (0, mustacheRenderer_1.substituteTemplate)(resources.get(templateKey), view);
        }
    }
    return ret;
};
exports.carlineConsumptionFromRawStrategy = carlineConsumptionFromRawStrategy;
